import { Connection } from '../../app/DTOs/Connection.component';

export class StopObject {
    private id: string;
    private code: number;
    private name: string;
    private lat: string;
    private lon: string;
    private connections: Connection[] = [];

    constructor( id: string, code: number, name: string, lat: string, lon: string, connections ) {
        this.id = id;
        this.code = code;
        this.name = name;
        this.lat = lat;
        this.lon  = lon;
        for (var i = 0; i < connections.length; i++) {
            this.connections.push(new Connection(connections[i].id, connections[i].color));
        }
        
    }

    public setId (id: string) { this.id = id; }
    public getId () { return this.id; }

    public setCode (code: number) { this.code = code; }
    public getCode () { return this.code; }
    
    public setName (name: string) { this.name = name; }
    public getName () { return this.name; }
    
    public setLat (lat: string) { this.lat = lat; }
    public getLat () { return this.lat; }
    
    public setLon (lon: string) { this.lon = lon; }
    public getLon () { return this.lon; }
    
    public setConnections (connections: Connection[]) { this.connections = connections; }
    public getConnections () { return this.connections; }
    
    public searchForId (idSearched: string) {
        if (idSearched == this.id) {
            return true;
        } else {
            return false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/DTOs/StopObject.component.ts